export { NumberProperties } from './NumberDocs'
export { CurrencyProperties } from './CurrencyDocs'
export { PercentProperties } from './PercentDocs'
export { RatingProperties } from './RatingDocs'
export { TrendProperties } from './TrendDocs'
export { LabelProperties } from './LabelDocs'
export { InfoProperties } from './InfoDocs'
export { InlineProperties } from './InlineDocs'
export { RootProperties } from './RootDocs'
export { ContentProperties } from './ContentDocs'
export { TextProperties } from './TextDocs'
